import { NonEmptyArray } from "fp-ts/lib/NonEmptyArray";
import { record, nonEmptyArray } from "fp-ts/lib";
import { literal } from "../../../shared/src/codecs/types/literal";
import { TAnyUnionOfFormsCodec, union } from "../../../shared/src/codecs/types/union";
import * as ContentType from "../../../domain/models/ContentType";
import { pipe } from "fp-ts/lib/function";
import { TAnyFormIOCodec } from "../../../shared/src/codecs/types/formIO";
import { CaseMemberChildrenForm, CaseMemberForm, TCaseMemberChildrenFormCodec, TCaseMemberFormCodec, TCaseSendInstructedEmailFormCodec, CaseSendInstructedEmailForm, TCaseMemberCreateIdCheckFormCodec, TCaseMemberIdCheckFormCodec, CaseMemberCreateIdCheckForm, CaseMemberIdCheckForm, CaseMemberSuggestedSimilarUserForm, TCaseMemberSuggestedSimilarUserFormCodec, CaseMemberReScreenIdCheckForm, TCaseMemberReScreenIdCheckFormCodec, CaseMemberRunScreeningIdCheckForm, TCaseMemberRunScreeningIdCheckFormCodec, CaseMemberSourceOfWealthForm, TCaseMemberSourceOfWealthFormCodec, CaseMemberNoDigitalContactChannelExemptionForm, TCaseMemberNoDigitalContactChannelExemptionFormCodec, CaseMemberFlagNeedsVideoCallForm, TCaseMemberFlagNeedsVideoCallFormCodec } from "../form/CaseMemberForm";
import { TAnyFormEditableCodec } from "../../../shared/src/codecs/types/formEditable";
import { BuyerSubmitsNewOfferFormEditable, TBuyerSubmitsNewOfferFormEditableCodec } from "../formEditable/BuyerSubmitsNewOfferFormEditable";
import { BuyerUpdatesConveyancerDetailsFormEditable, TBuyerUpdatesConveyancerDetailsFormEditableCodec } from "../formEditable/BuyerUpdatesConveyancerDetailsFormEditable";
import { BuyerUpdatesMortgageBrokerDetailsFormEditable, TBuyerUpdatesMortgageBrokerDetailsFormEditableCodec } from "../formEditable/BuyerUpdatesMortgageBrokerDetailsFormEditable";
import { BuyerUpdatesProofOfFundsFormEditable, TBuyerUpdatesProofOfFundsFormEditableCodec } from "../formEditable/BuyerUpdatesProofOfFundsFormEditable";
import { BuyerUpdatesClientDetailsFormEditable, TBuyerUpdatesClientDetailsFormEditableCodec } from "../formEditable/BuyerUpdatesClientDetailsFormEditable";
import { PublicOffersPageFormIO, TPublicOffersPageFormIOCodec } from "../formIO/PublicOffersPageFormIO";
import { TitleChecksPageFormIO, TTitleChecksPageFormIOCodec } from "../formIO/TitleChecksPageFormIO";
import { LegalCaseFormIO, TLegalCaseFormIOCodec } from "../formIO/LegalCaseFormIO";
import { CaseForm, TCaseFormCodec, CaseBankAccountForm, TCaseBankAccountFormCodec, CaseSetPayoutRecipientForm, TCaseSetPayoutRecipientFormCodec, TCaseSignOffAsReadyForExchangeFormCodec, CaseSignOffAsReadyForExchangeForm, TCaseInstructFormCodec, CaseInstructForm, TCaseRelatedTransactionCreateFormCodec, CaseRelatedTransactionCreateForm, TCaseRelatedTransactionCreateSearchResultsFormCodec, CaseRelatedTransactionCreateSearchResultsForm, TCaseRelatedTransactionForm1Codec, CaseRelatedTransactionForm1, TCaseRelatedTransactionDataFormCodec, CaseRelatedTransactionDataForm, CaseVideoVerificationCallCreateForm, TCaseVideoVerificationCallCreateFormCodec, CaseVideoVerificationCallListForm, TCaseVideoVerificationCallListFormCodec, CaseVideoVerificationCallAssociateWithUserForm, TCaseVideoVerificationCallAssociateWithUserFormCodec, CaseVideoVerificationCallUserForm, TCaseVideoVerificationCallUserFormCodec, CasePhoneVerificationCallLogForm, TCasePhoneVerificationCallLogFormCodec, TCaseSdltFormCodec, CaseSdltForm, CaseSdltDeclarationForm, TCaseSdltDeclarationFormCodec, TCaseNewRiskAssessmentFormCodec, CaseNewRiskAssessmentForm, CaseAuditForm, TCaseAuditFormCodec, TSubmitCaseAuditAsCompleteFormCodec, SubmitCaseAuditAsCompleteForm, CaseDualRepCreateForm, TCaseDualRepCreateFormCodec, CaseDualRepSearchResultsForm, TCaseDualRepSearchResultsFormCodec, CaseDualRepLinkedForm, TCaseDualRepLinkedFormCodec, CaseListingSearchForm, TCaseListingSearchFormCodec, CaseListingSearchResultForm, TCaseListingSearchResultFormCodec, CaseLinkedListingForm, TCaseLinkedListingFormCodec, TCreateCaseQuoteFilledFormCodec, CreateCaseQuoteFilledForm, TCaseQuoteSentToClientFormCodec, CaseQuoteSentToClientForm, TCaseQuoteAddAdditionalItemFormCodec, CaseQuoteAddAdditionalItemForm, TCaseQuoteRemoveAdditionalItemFormCodec, CaseQuoteRemoveAdditionalItemForm } from "../form/CaseForm";
import { CaseEpcSearchForm, TCaseEpcSearchFormCodec, CaseEpcAttachForm, TCaseEpcAttachFormCodec, CaseEpcRerunLookupForm, TCaseEpcRerunLookupFormCodec, CaseEpcMarkNotRequiredForm, TCaseEpcMarkNotRequiredFormCodec, CaseEpcSetSortedForm, TCaseEpcSetSortedFormCodec, ClientCaseEpcWhoArrangesForm, TClientCaseEpcWhoArrangesFormCodec } from "../form/CaseEpcForm";
import { NewCaseMemberFormIO, TNewCaseMemberFormIOCodec } from "../formIO/NewCaseMemberFormIO";
import { RemoveUserNumberFormIO, TRemoveUserNumberFormIOCodec } from "../formIO/RemoveUserNumberFormIO";
import { RemoveCaseMemberFormIO, TRemoveCaseMemberFormIOCodec } from "../formIO/RemoveCaseMemberFormIO";
import { ListingDataFormIO, TListingDataFormIOCodec } from "../formIO/ListingDataFormIO";
import { ListingPnlFormIO, TListingPnlFormIOCodec } from "../formIO/ListingPnlFormIO";
import { ListingsProfitReportFormIO, TListingsProfitReportFormIOCodec } from "../formIO/ListingsProfitReportFormIO";
import { ListingFull1Editable, TListingFull1EditableCodec } from "../formEditable/ListingEditable";
import { PartyDataFormIO, TPartyDataFormIOCodec } from "../formIO/PartyDataFormIO";
import { Party1Editable, TParty1EditableCodec } from "../Party";
import { PartyMemberCreateForm, TPartyMemberCreateFormCodec } from "../form/PartyMemberCreateForm";
import { AddPartyListingForm, TAddPartyListingFormCodec } from "../form/AddPartyListingForm";
import { JobsFormIO, TJobsFormIOCodec } from "../formIO/JobsIO";
import { NewListingAdHocTaskFormIO, TNewListingAdHocTaskFormIOCodec } from "../formIO/NewListingAdHocTaskFormIO";
import { AdHocTaskDeferFormIO, TAdHocTaskDeferFormIOCodec } from "../formIO/AdHocTaskDeferFormIO";
import { AdHocTaskReassignFormIO, TAdHocTaskReassignFormIOCodec } from "../formIO/AdHocTaskReassignFormIO";
import { ListingAdHocTaskEditable, TListingAdHocTaskEditableCodec } from "../formEditable/ListingAdHocTaskEditable";
import { ListingPhotoFileIO, TListingPhotoFileIOCodec } from "../fileIO/ListingPhotoFileIO";
import { IntroducerLogoFileIO, TIntroducerLogoFileIOCodec } from "../fileIO/IntroducerLogoFileIO";
import { TAnyFileIOCodec } from "../../../shared/src/codecs/types/fileIO";
import { ListingDocumentFileIO, TListingDocumentFileIOCodec } from "../fileIO/ListingDocumentFileIO";
import { DeleteListingDocumentFormIO, TDeleteListingDocumentFormIOCodec } from "../formIO/DeleteListingDocumentFormIO";
import { ProofOfFundsDocumentFileIO, TProofOfFundsDocumentFileIOCodec } from "../fileIO/ProofOfFundsDocumentFileIO";
import { DeleteProofOfFundsDocumentFormIO, TDeleteProofOfFundsDocumentFormIOCodec } from "../formIO/DeleteProofOfFundsDocumentFormIO";
import { GetProofOfFundsDocumentsFormIO, TGetProofOfFundsDocumentsFormIOCodec } from "../formIO/GetProofOfFundsDocumentsFormIO";
import { DeleteListingPhotoFormIO, TDeleteListingPhotoFormIOCodec } from "../formIO/DeleteListingPhotoFormIO";
import { ListingDocumentEditable, TListingDocumentEditableCodec } from "../ListingDocument";
import { ListingEnquiryAdHocTasksForm, ListingEnquiryForm, ListingEnquiryInnerForm, ListingEnquiryNewAdHocTaskForm, ListingEnquiryOfferForm, TListingEnquiryAdHocTasksFormCodec, TListingEnquiryFormCodec, TListingEnquiryInnerFormCodec, TListingEnquiryNewAdHocTaskFormCodec, TListingEnquiryOfferFormCodec } from "../formEditable/ListingEnquiryForm";
import { TAnyFormCodec } from "../../../shared/src/codecs/types/form";
import { ListingSignMovementEditForm, TListingSignMovementEditFormCodec } from "../form/ListingSignMovementEditForm";
import { ListingSignMovementCreateForm, TListingSignMovementCreateFormCodec } from "../form/ListingSignMovementCreateForm";
import { AdminPageFormIO, TAdminPageFormIOCodec } from "../formIO/AdminPageFormIO";
import { AdminUserEditable, TAdminUserEditableCodec } from "../formEditable/AdminUserEditable";
import { GetUserDeletionBlockersFormIO, TGetUserDeletionBlockersFormIOCodec } from "../formIO/GetUserDeletionBlockersFormIO";
import { AutoReassignUserWorkFormIO, TAutoReassignUserWorkFormIOCodec } from "../formIO/AutoReassignUserWorkFormIO";
import { PhoneNumberForm, TPhoneNumberFormCodec } from "../form/PhoneNumberForm";
import { ListingSellerUserCreateForm, TListingSellerUserCreateFormCodec } from "../form/ListingSellerUserCreateForm";
import { ListingSellerSuggestedSimilarUserForm, ListingSellerUserEditForm, TListingSellerSuggestedSimilarUserFormCodec, TListingSellerUserEditFormCodec } from "../form/ListingSellerUserEditForm";
import { ListingSellerUserDeleteForm, TListingSellerUserDeleteFormCodec } from "../form/ListingSellerUserDeleteForm";
import { MarkListingAgencyLostForm, TMarkListingAgencyLostFormCodec } from "../form/MarkListingAgencyLostForm";
import { ReinstateListingForm, TReinstateListingFormCodec } from "../form/ReinstateListingForm";
import { ConfirmListingBackOnPortalsForm, TConfirmListingBackOnPortalsFormCodec } from "../form/ConfirmListingBackOnPortalsForm";
import { ProbateGrantMatchActionForm, TProbateGrantMatchActionFormCodec } from "../form/ProbateGrantMatchActionForm";
import { SendListingToAuctionForm, TSendListingToAuctionFormCodec } from "../form/SendListingToAuctionForm";
import { TakeListingLiveForm, TTakeListingLiveFormCodec } from "../form/TakeListingLiveForm";
import { UnsendListingFromAuctionForm, TUnsendListingFromAuctionFormCodec } from "../form/UnsendListingFromAuctionForm";
import { NewUserNumberFormIO, TNewUserNumberFormIOCodec } from "../formIO/NewUserNumberFormIO";
import { CaseNewPropertyForm, TCaseNewPropertyFormCodec } from "../form/CaseNewPropertyForm";
import { CasePropertyForm, TCasePropertyFormCodec } from "../form/CasePropertyForm";
import { CasesSearchForm, TCasesSearchFormCodec } from "../form/CasesSearchForm";
import { CaseNewOtherSideMemberForm, TCaseNewOtherSideMemberFormCodec } from "../form/CaseNewOtherSideMemberForm";
import { CaseOtherSideMemberForm, TCaseOtherSideMemberFormCodec } from "../form/CaseOtherSideMemberForm";
import { CaseManagementCompaniesForm, TCaseManagementCompaniesFormCodec, CaseManagementCompanyForm, TCaseManagementCompanyFormCodec, CreateCaseManagementCompanyForm, TCreateCaseManagementCompanyFormCodec, ManagementCompanySearchForm, TManagementCompanySearchFormCodec } from "../form/ManagementCompanyForm";
import { TTwoFactorAuthFormCodec, TwoFactorAuthForm, TTwoFactorAuthCodeFormCodec, TwoFactorAuthCodeForm, TResendTwoFactorAuthCodeFormCodec, ResendTwoFactorAuthCodeForm } from "../form/TwoFactorAuthForm";
import { AdminResetUserAuthenticatorForm, AuthenticatorPageForm, BeginAuthenticatorEnrolmentForm, ConfirmAuthenticatorEnrolmentForm, RemoveAuthenticatorForm, TAdminResetUserAuthenticatorFormCodec, TAuthenticatorPageFormCodec, TBeginAuthenticatorEnrolmentFormCodec, TConfirmAuthenticatorEnrolmentFormCodec, TRemoveAuthenticatorFormCodec } from "../form/AuthenticatorForm";
import { ClientCaseBankAccountForm, ClientCaseCreateBankAccountForm, ClientCaseForm, TClientCaseBankAccountFormCodec, TClientCaseCreateBankAccountFormCodec, TClientCaseFormCodec, TClientCaseSubmitBankAccountsForVerificationFormCodec, ClientCaseSubmitBankAccountsForVerificationForm, TClientCaseCreateIdVerificationLinkFormCodec, ClientCaseCreateIdVerificationLinkForm, TClientCaseIdentityVerificationUserFormCodec, ClientCaseIdentityVerificationUserForm, ClientCaseUserSaysPaymentPaidForm, TClientCaseUserSaysPaymentPaidFormCodec, ClientCaseCompanyForm, TClientCaseCompanyFormCodec, TClientCaseCreateUserFormCodec, ClientCaseCreateUserForm, TClientCaseUserFormCodec, ClientCaseUserForm, TClientCaseRelatedTransactionQuestionFormCodec, ClientCaseRelatedTransactionQuestionForm, ClientCaseRelatedTransactionAddressForm, TClientCaseRelatedTransactionAddressFormCodec, ClientCaseVideoVerificationCallAvailableTimesForm, TClientCaseVideoVerificationCallAvailableTimesFormCodec, ClientCaseVideoVerificationCallCreateForm, TClientCaseVideoVerificationCallCreateFormCodec, ClientCaseIdentityVerificationUserProofOfAddressForm, TClientCaseIdentityVerificationUserProofOfAddressFormCodec, TClientCaseSdltFormCodec, ClientCaseSdltForm, TClientCasePurchasePaymentDetailsFormCodec, ClientCasePurchasePaymentDetailsForm, ClientCaseChargeForm, TClientCaseChargeFormCodec, TClientCaseSubmitStepAsCompleteFormCodec, ClientCaseSubmitStepAsCompleteForm, ClientCaseRemortgageMortgageDetailsForm, TClientCaseRemortgageMortgageDetailsFormCodec, TClientCaseDivorceDocumentFormCodec, ClientCaseDivorceDocumentForm, TClientCaseIlaWaiverFormCodec, ClientCaseIlaWaiverForm, TClientCaseJointOwnershipHeldAsFormCodec, ClientCaseJointOwnershipHeldAsForm, ClientCaseDeclarationOfTrustReferralForm, TClientCaseDeclarationOfTrustReferralFormCodec, TClientCaseWillReferralFormCodec, ClientCaseWillReferralForm, TClientCaseCasePifFormCodec, ClientCaseCasePifForm, TCaseCasePifReadFormCodec, CaseCasePifReadForm, ClientCaseSignCasePifForm, TClientCaseSignCasePifFormCodec, ClientCaseUpdateCasePifFreeTextForm, TClientCaseUpdateCasePifFreeTextFormCodec, ClientCaseSetCasePifDontKnowForm, TClientCaseSetCasePifDontKnowFormCodec, ClientCasePepDeclarationSubmitForm, TClientCasePepDeclarationSubmitFormCodec, ClientCaseOnboardingCompleteEmailForm, TClientCaseOnboardingCompleteEmailFormCodec } from "../form/ClientCaseForm";
import { LegalCasesKeyDatesFormIO, TLegalCasesKeyDatesFormIOCodec } from "../formIO/LegalCasesKeyDatesFormIO";
import { CaseNewLedgerEntryForm, TCaseNewLedgerEntryFormCodec } from "../form/CaseNewLedgerEntryForm";
import { CaseLedgerForm, TCaseLedgerFormCodec } from "../form/CaseLedgerForm";
import { CaseConflictOfInterestForm, TCaseConflictOfInterestFormCodec } from "../form/CaseConflictsOfInterestForms";
import { TCaseLedgerEntryFormCodec, CaseLedgerEntryForm } from "../form/CaseLedgerEntryForm";
import { TCaseLedgerMarkLedgerAsFinalFormCodec, CaseLedgerMarkLedgerAsFinalForm, TCaseLedgerRollbackFormCodec, CaseLedgerRollbackForm } from "../form/CaseLedgerMarkLedgerAsFinalForm";
import { CaseAdHocJobForm, CaseAdHocJobNewForm, TCaseAdHocJobFormCodec, TCaseAdHocJobNewFormCodec } from "../form/CaseAdHocJobForms";
import { TLegalMailboxAccessEditFormCodec, LegalMailboxAccessEditForm } from "../form/LegalMailboxAccessEditForm";
import { EmailAttachmentSearchForm, TEmailAttachmentSearchFormCodec } from "../form/EmailAttachmentSearchForm";
import { TriageBulkEmailMarkAsIrrelevantForm, DetailedEmailForm, TriageEmailAssignToCaseAndUserForm, TriageEmailAssignToCaseForm, TriageEmailAssignToCaseSearchForm, TriageEmailAssignToCaseWithAdhocForm, TriageEmailAssignToUserOnlyForm, TriageEmailMarkAsIrrelevantForm, TriageEmailMarkAsResolvedForm, TriageForm, TTriageBulkEmailMarkAsIrrelevantFormCodec, TDetailedEmailFormCodec, TTriageEmailAssignToCaseAndUserFormCodec, TTriageEmailAssignToCaseFormCodec, TTriageEmailAssignToCaseSearchFormCodec, TTriageEmailAssignToCaseWithAdhocFormCodec, TTriageEmailAssignToUserOnlyFormCodec, TTriageEmailMarkAsIrrelevantFormCodec, TTriageEmailMarkAsResolvedFormCodec, TTriageFormCodec, TriageEmailDisassociateFromCaseForm, TTriageEmailDisassociateFromCaseFormCodec } from "../form/TriageForm";
import { EmailCompositionForm, TEmailCompositionFormCodec } from "../form/EmailCompositionForm";
import { ToggleAwayStatusForm, TToggleAwayStatusFormCodec, GetStaffInboxesForm, TGetStaffInboxesFormCodec } from "../form/StaffAwayForm";
import { TInboxCountFormCodec, InboxCountForm } from "../form/InboxCountForm";
import { CaseTitleRestrictionForm, CaseChargesAndTitleRestrictionsCaseForm, CaseChargesAndRestrictionsForm, CreateCaseTitleRestrictionForm, TCaseTitleRestrictionFormCodec, TCaseChargesAndTitleRestrictionsCaseFormCodec, TCaseChargesAndRestrictionsFormCodec, TCreateCaseTitleRestrictionFormCodec, CreateCaseChargeForm, CaseChargeForm, TCaseChargeFormCodec, TCreateCaseChargeFormCodec } from "../form/CaseChargesAndRestrictionForm";
import { CaseChargeRedemptionCreateForm, CaseChargeRedemptionForm, CaseChargeRedemptionUploadForm, TCaseChargeRedemptionCreateFormCodec, TCaseChargeRedemptionFormCodec, TCaseChargeRedemptionUploadFormCodec } from "../form/CaseChargeRedemptionForm";
import { IntroducerBankDetailsForm, IntroducerCreateForm, IntroducerExistingAgreementForm, IntroducerForm, IntroducersForm, IntroducerUploadAgreementForm, TIntroducerBankDetailsFormCodec, TIntroducerCreateFormCodec, TIntroducerExistingAgreementFormCodec, TIntroducerFormCodec, TIntroducersFormCodec, TIntroducerUploadAgreementFormCodec } from "../form/IntroducerForm";
import { CaseCustomerSatisfactionDeleteComplaintAcknowledgedForm, CaseCustomerSatisfactionDeleteComplaintResolvedForm, CaseCustomerSatisfactionNewComplaintAcknowledgedForm, CaseCustomerSatisfactionNewComplaintResolvedForm, TCaseCustomerSatisfactionDeleteComplaintAcknowledgedFormCodec, TCaseCustomerSatisfactionDeleteComplaintResolvedFormCodec, TCaseCustomerSatisfactionNewComplaintAcknowledgedFormCodec, TCaseCustomerSatisfactionNewComplaintResolvedFormCodec, CaseCustomerSatisfactionDeleteFormalisedAsComplaintForm, CaseCustomerSatisfactionDeleteNoteForm, CaseCustomerSatisfactionDeleteRaisedWithOmbudsmanForm, CaseCustomerSatisfactionDeleteSentimentForm, CaseCustomerSatisfactionForm, CaseCustomerSatisfactionNewAssignmentForm, CaseCustomerSatisfactionNewDeferForm, CaseCustomerSatisfactionNewFormalisedAsComplaintForm, CaseCustomerSatisfactionNewNoteForm, CaseCustomerSatisfactionNewRaisedWithOmbudsmanForm, CaseCustomerSatisfactionNewSentimentForm, CaseCustomerSatisfactionNoteTogglePinForm, TCaseCustomerSatisfactionDeleteFormalisedAsComplaintFormCodec, TCaseCustomerSatisfactionDeleteNoteFormCodec, TCaseCustomerSatisfactionDeleteRaisedWithOmbudsmanFormCodec, TCaseCustomerSatisfactionDeleteSentimentFormCodec, TCaseCustomerSatisfactionFormCodec, TCaseCustomerSatisfactionNewAssignmentFormCodec, TCaseCustomerSatisfactionNewDeferFormCodec, TCaseCustomerSatisfactionNewFormalisedAsComplaintFormCodec, TCaseCustomerSatisfactionNewNoteFormCodec, TCaseCustomerSatisfactionNewRaisedWithOmbudsmanFormCodec, TCaseCustomerSatisfactionNewSentimentFormCodec, TCaseCustomerSatisfactionNoteTogglePinFormCodec } from "../form/CaseCustomerSatisfactionForm";
import { CaseComplianceRaiseForm, CaseComplianceRaiseNewForm, CaseComplianceRaiseRevokeForm, CaseComplianceRaisesForm, TCaseComplianceRaiseFormCodec, TCaseComplianceRaiseNewFormCodec, TCaseComplianceRaiseRevokeFormCodec, TCaseComplianceRaisesFormCodec } from "../form/CaseComplianceForm";
import { TClientCompanyPartnershipPageFormCodec, ClientCompanyPartnershipPageForm, ClientCompanyPartnershipForm, TClientCompanyPartnershipFormCodec, ClientCompanyPartnershipCreateForm, TClientCompanyPartnershipCreateFormCodec, ClientCompanyPartnershipDeleteForm, TClientCompanyPartnershipDeleteFormCodec, ClientCompanyPartnershipReviewForm, TClientCompanyPartnershipReviewFormCodec, ClientCompanyPartnershipContractUploadForm, TClientCompanyPartnershipContractUploadFormCodec, TClientCompanyPartnershipContractFormCodec, ClientCompanyPartnershipContractForm, TClientCompanyPartnershipUserFormCodec, ClientCompanyPartnershipUserForm, TClientCompanyPartnershipUserPhoneNumberCreateFormCodec, ClientCompanyPartnershipUserPhoneNumberCreateForm, ClientCompanyPartnershipUserPhoneNumberMakePrimaryForm, TClientCompanyPartnershipUserPhoneNumberMakePrimaryFormCodec, ClientCompanyPartnershipUserPhoneNumberDeleteForm, TClientCompanyPartnershipUserPhoneNumberDeleteFormCodec } from "../form/ClientCompanyPartnershipForm";
import { ProbateHelplineCallbackForm, ProbateHelplineCallbackMarkCompleteForm, ProbateHelplineCallbackTypeForm, TProbateHelplineCallbackFormCodec, TProbateHelplineCallbackMarkCompleteFormCodec, TProbateHelplineCallbackTypeFormCodec } from "../form/ProbateHelplineCallbackForm";
import { MarketingCampaignCreateForm, MarketingCampaignForm, MarketingCampaignsForm, TMarketingCampaignCreateFormCodec, TMarketingCampaignFormCodec, TMarketingCampaignsFormCodec } from "../form/MarketingCampaignForm";
import { QuoteRateCreatedForm, QuoteRatePageForm, QuoteRateIntroducerIdForm, TQuoteRateCreatedFormCodec, TQuoteRatePageFormCodec, TQuoteRateIntroducerIdFormCodec } from "../form/QuoteRateForm";
import { TUuidFormCodec, UuidForm } from "../form/UuidForm";
import { TCasePropertyReferredDocumentsFormCodec, CasePropertyReferredDocumentsForm } from "../form/CasePropertyReferredDocumentsForm";
import { PublicCreateQuoteAddressForm, PublicCreateQuoteFilledForm, TPublicCreateQuoteAddressFormCodec, TPublicCreateQuoteFilledFormCodec } from "../form/PublicQuoteForm";
import { PublicQuoteInstructLinkForm, TPublicQuoteInstructLinkFormCodec } from "../form/PublicQuoteInstructLinkForm";
import { CaseAutoAssignmentForm, CaseAutoAssignmentPageForm, TCaseAutoAssignmentFormCodec, TCaseAutoAssignmentPageFormCodec } from "../form/CaseAutoAssignmentForm";
import { LenderForm, LendersPageForm, TLenderFormCodec, TLendersPageFormCodec } from "../form/LenderForm";
import { RoadblockAssignmentForm, RoadblockAssignmentPageForm, TRoadblockAssignmentFormCodec, TRoadblockAssignmentPageFormCodec } from "../form/RoadblockAssignmentForm";
import { EmailTemplateContextForm, TEmailTemplateContextFormCodec } from "../form/EmailTemplateContextForm";
import { EmailTemplateForm, EmailTemplatesForm, TEmailTemplateFormCodec, TEmailTemplatesFormCodec } from "../form/EmailTemplatesForm";
import { RoadblockAssignForm, RoadblockAwaitForm, RoadblockCancelAwaitForm, RoadblockCheckListItemManualForm, RoadblockForm, RoadblockSignOffForm, RoadblocksForm, RoadblocksForm2, TRoadblockAssignFormCodec, TRoadblockAwaitFormCodec, TRoadblockCancelAwaitFormCodec, TRoadblockCheckListItemManualFormCodec, TRoadblockFormCodec, TRoadblockSignOffFormCodec, TRoadblocksForm2Codec, TRoadblocksFormCodec } from "../form/RoadblockForm";
import { ProbateLeadForm } from "../form/ProbateLeadForm";
import { TProbateLeadFormCodec } from "../form/ProbateLeadForm";
import { ChatsMessageForm, TChatsMessageFormCodec, UpdateChatMessageForm, TUpdateChatMessageFormCodec, SetChatMessagePinnedForm, TSetChatMessagePinnedFormCodec } from "../form/ChatsMessageForm";
import { CaseTimelineForm, TCaseTimelineFormCodec } from "../form/CaseTimelineForm";
import { TCaseContractSectionFormCodec, CaseContractSectionForm } from "../form/CaseContractSectionForm";
import { CaseContractDetailsForm, TCaseContractDetailsFormCodec } from "../form/CaseContractDetailsForm";
import { CreateCaseDeadlineChangeForm, TCreateCaseDeadlineChangeFormCodec, DeleteCaseDeadlineChangeForm, TDeleteCaseDeadlineChangeFormCodec } from "../form/CaseDeadlineChangeForm";
import { CaseTitleChecksForm, TCaseTitleChecksFormCodec } from "../form/CaseTitleChecksForm";
import { CaseTitleCheckForm, TCaseTitleCheckFormCodec } from "../form/CaseTitleCheckForm";
import { PublicPropertyReportTitleSearchForm, TPublicPropertyReportTitleSearchFormCodec, PublicPropertyReportCreateForm, TPublicPropertyReportCreateFormCodec, TPublicPropertyReportAddressSearchFormCodec, PublicPropertyReportAddressSearchForm } from "../form/PublicPropertyReportForm";
import { PublicIntroducerSearchForm, TPublicIntroducerSearchFormCodec } from "../form/PublicIntroducerSearchForm";
import { CasePropertyNewTitleIssueForm, TCasePropertyNewTitleIssueFormCodec } from "../form/CasePropertyNewTitleIssueForm";
import { CasePropertyDeleteTitleIssueForm, TCasePropertyDeleteTitleIssueFormCodec } from "../form/CasePropertyDeleteTitleIssueForm";
import { SessionFeatureToggleForm, TSessionFeatureToggleFormCodec } from "../form/SessionFeatureToggleForm";
import { CasesCaseCreateAdhocForm, CasesCaseForm, CasesCaseTaskFormAdhocForCasesView, CasesCaseTaskFormUpdatableForCasesView, CasesCaseViewForm, CasesDayViewForm, CasesSailHomesReportForm, TCasesCaseCreateAdhocFormCodec, TCasesCaseFormCodec, TCasesCaseTaskFormAdhocCodec, TCasesCaseTaskFormUpdatableCodec, TCasesCaseViewFormCodec, TCasesDayViewFormCodec, TCasesSailHomesReportFormCodec } from "../form/CasesForm";
import { CasesDayViewRoadblocksForm, TCasesDayViewRoadblocksFormCodec } from "../form/RoadblockDayViewForm";
import { CasesDayViewBulkRescheduleForm, CasesDayViewWeekCountsForm, TCasesDayViewBulkRescheduleFormCodec, TCasesDayViewWeekCountsFormCodec, TCasesDayViewBulkAwaitFormCodec, CasesDayViewBulkAwaitForm } from "../form/CasesDayViewWeekCountsForm";
import { CaseChaseModeForm, TCaseChaseModeFormCodec, ChaseModeUpdateFormWithChaseReasons, TChaseModeUpdateFormWithChaseReasonsCodec, ChaseModeUpdateForm, TChaseModeUpdateFormCodec, CloseAwaitingNewCaseForm, TCloseAwaitingNewCaseFormCodec } from "../form/CasesChaseTransitionForm";
import { CreateServiceBearerTokenForm, TCreateServiceBearerTokenFormCodec } from "../form/CreateServiceBearerTokenForm";
import { CreateIntroducerApiTokenForm, RevokeIntroducerApiTokenForm, TCreateIntroducerApiTokenFormCodec, TRevokeIntroducerApiTokenFormCodec } from "../form/IntroducerApiTokenForm";
import { NewTransferSetupRecordForCaseForm, TNewTransferSetupRecordForCaseFormCodec } from "../form/NewTransferSetupRecordForCaseForm";
import { TTransferSetupRecordFormCodec, TransferSetupRecordForm } from "../form/TransferSetupRecordForm";
import { CreateStaffUserForm, TCreateStaffUserFormCodec } from "../form/CreateStaffUserForm";
import { ChangeStaffUserPasswordForm, TChangeStaffUserPasswordFormCodec } from "../form/ChangeStaffUserPasswordForm";
import { ListingValuationFormIO, TListingValuationFormIOCodec } from "../formIO/ListingValuationFormIO";
import { ListingValuationTabFormIO, TListingValuationTabFormIOCodec } from "../formIO/ListingValuationTabFormIO";
import { ListingRoadblockDetailForm, ListingRoadblocksForm, TListingRoadblockDetailFormCodec, TListingRoadblocksFormCodec,
    ListingRoadblocksDashboardForm,
    TListingRoadblocksDashboardFormCodec,
    ListingRoadblocksDashboardWeekCountsForm,
    TListingRoadblocksDashboardWeekCountsFormCodec,
} from "../form/ListingRoadblockForm";
import { ListingValuationActionFormIO, TListingValuationActionFormIOCodec } from "../formIO/ListingValuationActionFormIO";
import { ListingValSubmitFormIO, TListingValSubmitFormIOCodec } from "../formIO/ListingValSubmitFormIO";

export type TAnyFormOperationCodec = TAnyFormEditableCodec | TAnyFormIOCodec | TAnyFileIOCodec | TAnyFormCodec | TAnyUnionOfFormsCodec;

export type TFormOperationCodecs = {
    GetPublicOffersPageOffers: TPublicOffersPageFormIOCodec,
    GetCase: TLegalCaseFormIOCodec,
    GetCaseContractSection: TCaseContractSectionFormCodec,
    GetCaseTitleChecks: TCaseTitleChecksFormCodec,
    UpdateCaseTitleCheck: TCaseTitleCheckFormCodec,
    CreateCasePropertyNewTitleIssueForm: TCasePropertyNewTitleIssueFormCodec,
    DeleteCasePropertyTitleIssue: TCasePropertyDeleteTitleIssueFormCodec,
    UpdateCaseContractSection: TCaseContractDetailsFormCodec,
    CreateCaseDeadlineChange: TCreateCaseDeadlineChangeFormCodec,
    DeleteCaseDeadlineChange: TDeleteCaseDeadlineChangeFormCodec,
    CreateCaseProperty: TCaseNewPropertyFormCodec,
    UpdateCaseProperty: TCasePropertyFormCodec,
    DeleteCaseProperty: TCasePropertyFormCodec,
    OrderCasePropertyTitleRegister: TUuidFormCodec,
    OrderCasePropertyReferredDocument: TUuidFormCodec,
    GetCasePropertyReferredDocuments: TCasePropertyReferredDocumentsFormCodec,
    CreateListingFromCaseProperty: TUuidFormCodec,
    UpdateLegalCase: TCaseFormCodec,
    BuyerSubmitsNewOffer: TBuyerSubmitsNewOfferFormEditableCodec,
    BuyerUpdatesConveyancerDetails: TBuyerUpdatesConveyancerDetailsFormEditableCodec,
    BuyerUpdatesMortgageBrokerDetails: TBuyerUpdatesMortgageBrokerDetailsFormEditableCodec,
    BuyerUpdatesProofOfFunds: TBuyerUpdatesProofOfFundsFormEditableCodec,
    BuyerUpdatesClientDetails: TBuyerUpdatesClientDetailsFormEditableCodec,
    GetTitleChecksPage: TTitleChecksPageFormIOCodec,
    AutocompleteCaseDetailsAddress: TCasePropertyFormCodec,
    CreateCaseMember: TNewCaseMemberFormIOCodec,
    RemoveCaseMember: TRemoveCaseMemberFormIOCodec,
    UpdateCaseMember: TCaseMemberFormCodec,
    UpdateCaseMemberCaseUser: TCaseMemberChildrenFormCodec,
    UpdateCaseMemberSourceOfWealth: TCaseMemberSourceOfWealthFormCodec,
    UpdateCaseMemberNoDigitalContactChannelExemption: TCaseMemberNoDigitalContactChannelExemptionFormCodec,
    CreateUserNumber: TNewUserNumberFormIOCodec,
    UpdateUserNumber: TPhoneNumberFormCodec,
    RemoveUserNumber: TRemoveUserNumberFormIOCodec,
    GetListingData: TListingDataFormIOCodec,
    GetListingPnl: TListingPnlFormIOCodec,
    GetListingsProfitReport: TListingsProfitReportFormIOCodec,
    UpdateListingFull: TListingFull1EditableCodec,
    GetPartyData: TPartyDataFormIOCodec,
    UpdateParty: TParty1EditableCodec,
    PartyMemberCreate: TPartyMemberCreateFormCodec,
    AddPartyListing: TAddPartyListingFormCodec,
    GetJobs: TJobsFormIOCodec,
    CreateListingAdHocTask: TNewListingAdHocTaskFormIOCodec,
    UpdateListingAdHocTask: TListingAdHocTaskEditableCodec,
    UploadListingPhoto: TListingPhotoFileIOCodec,
    UploadListingDocument: TListingDocumentFileIOCodec,
    DeleteListingDocument: TDeleteListingDocumentFormIOCodec,
    DeleteListingPhoto: TDeleteListingPhotoFormIOCodec,
    UploadProofOfFundsDocument: TProofOfFundsDocumentFileIOCodec,
    DeleteProofOfFundsDocument: TDeleteProofOfFundsDocumentFormIOCodec,
    GetProofOfFundsDocuments: TGetProofOfFundsDocumentsFormIOCodec,
    UpdateUserLegalMailboxAccess: TLegalMailboxAccessEditFormCodec,
    UpdateListingDocument: TListingDocumentEditableCodec,
    GetListingEnquiry: TListingEnquiryFormCodec,
    UpdateListingEnquiry: TListingEnquiryInnerFormCodec,
    CreateListingSignMovement: TListingSignMovementCreateFormCodec,
    UpdateListingSignMovement: TListingSignMovementEditFormCodec,
    DeleteListingSignMovement: TListingSignMovementEditFormCodec,
    CreateListingEnquiryAdHocTask: TListingEnquiryNewAdHocTaskFormCodec,
    UpdateListingEnquiryAdHocTask: TListingEnquiryAdHocTasksFormCodec,
    ReassignListingAdHocTask: TAdHocTaskReassignFormIOCodec,
    ReassignListingEnquiryAdHocTask: TAdHocTaskReassignFormIOCodec,
    DeferListingAdHocTask: TAdHocTaskDeferFormIOCodec,
    DeferListingEnquiryAdHocTask: TAdHocTaskDeferFormIOCodec,
    GetAdminPage: TAdminPageFormIOCodec,
    UpdateAdminUser: TAdminUserEditableCodec,
    GetUserDeletionBlockers: TGetUserDeletionBlockersFormIOCodec,
    AutoReassignUserWork: TAutoReassignUserWorkFormIOCodec,
    UpdateListingEnquiryOffer: TListingEnquiryOfferFormCodec,
    ListingSellerUserCreate: TListingSellerUserCreateFormCodec,
    ListingSellerUserEdit: TListingSellerUserEditFormCodec,
    ListingSellerUserDelete: TListingSellerUserDeleteFormCodec,
    MarkListingAgencyLost: TMarkListingAgencyLostFormCodec,
    ReinstateListing: TReinstateListingFormCodec,
    ConfirmListingBackOnPortals: TConfirmListingBackOnPortalsFormCodec,
    ConfirmProbateGrantMatch: TProbateGrantMatchActionFormCodec,
    DismissProbateGrantMatch: TProbateGrantMatchActionFormCodec,
    SendListingToAuction: TSendListingToAuctionFormCodec,
    TakeListingLive: TTakeListingLiveFormCodec,
    UnsendListingFromAuction: TUnsendListingFromAuctionFormCodec,
    ListingSwapSellerPartyMember: TListingSellerSuggestedSimilarUserFormCodec,
    CasesSearch: TCasesSearchFormCodec,
    CreateCaseOtherSideMember: TCaseNewOtherSideMemberFormCodec,
    UpdateCaseOtherSideMember: TCaseOtherSideMemberFormCodec,
    DeleteCaseOtherSideMember: TCaseOtherSideMemberFormCodec,
    GetCaseManagementCompanies: TCaseManagementCompaniesFormCodec,
    GetManagementCompanySearch: TManagementCompanySearchFormCodec,
    CreateCaseManagementCompany: TCreateCaseManagementCompanyFormCodec,
    UpdateCaseManagementCompany: TCaseManagementCompanyFormCodec,
    DeleteCaseManagementCompany: TCaseManagementCompanyFormCodec,
    GetTwoFactorAuth: TTwoFactorAuthFormCodec,
    SubmitTwoFactorAuthCode: TTwoFactorAuthCodeFormCodec,
    ResendTwoFactorAuthCode: TResendTwoFactorAuthCodeFormCodec,
    GetAuthenticatorPage: TAuthenticatorPageFormCodec,
    BeginAuthenticatorEnrolment: TBeginAuthenticatorEnrolmentFormCodec,
    ConfirmAuthenticatorEnrolment: TConfirmAuthenticatorEnrolmentFormCodec,
    RemoveAuthenticator: TRemoveAuthenticatorFormCodec,
    AdminResetUserAuthenticator: TAdminResetUserAuthenticatorFormCodec,
    GetClientCase: TClientCaseFormCodec,
    SendClientCaseOnboardingCompleteEmail: TClientCaseOnboardingCompleteEmailFormCodec,
    SubmitClientCaseUserAgreeToTOEStepAsComplete: TClientCaseSubmitStepAsCompleteFormCodec,
    SubmitClientCaseUserPepDeclarationStepAsComplete: TClientCasePepDeclarationSubmitFormCodec,
    SubmitClientCaseUserDualRepConsentStepAsComplete: TClientCaseSubmitStepAsCompleteFormCodec,
    SendCaseInstructedEmail: TCaseSendInstructedEmailFormCodec,
    CreateClientCaseBankAccount: TClientCaseCreateBankAccountFormCodec,
    UpdateClientCaseBankAccount: TClientCaseBankAccountFormCodec,
    DeleteClientCaseBankAccount: TClientCaseBankAccountFormCodec,
    SubmitClientCaseBankAccountsForVerification: TClientCaseSubmitBankAccountsForVerificationFormCodec,
    GetLegalCasesKeyDates: TLegalCasesKeyDatesFormIOCodec,
    UpdateCaseBankAccount: TCaseBankAccountFormCodec,
    SetCasePayoutRecipient: TCaseSetPayoutRecipientFormCodec,
    CreateCaseLedgerEntry: TCaseNewLedgerEntryFormCodec,
    GetCaseLedger: TCaseLedgerFormCodec,
    DeleteCaseLedgerEntry: TCaseLedgerEntryFormCodec,
    UpdateCaseLedgerEntry: TCaseLedgerEntryFormCodec,
    CreateStripeIdVerificationLink: TClientCaseCreateIdVerificationLinkFormCodec,
    UpdateClientCaseUserIdCheck: TClientCaseIdentityVerificationUserFormCodec,
    CreateCaseMemberIdCheck: TCaseMemberCreateIdCheckFormCodec,
    UpdateCaseMemberIdCheck: TCaseMemberIdCheckFormCodec,
    ReScreenCaseMemberIdCheck: TCaseMemberReScreenIdCheckFormCodec,
    RunScreeningCaseMemberIdCheck: TCaseMemberRunScreeningIdCheckFormCodec,
    FlagCaseMemberNeedsVideoCall: TCaseMemberFlagNeedsVideoCallFormCodec,
    UpdateCaseConflictOfInterest: TCaseConflictOfInterestFormCodec,
    CaseLedgerMarkLedgerAsFinal: TCaseLedgerMarkLedgerAsFinalFormCodec,
    AutocompleteClientVerificationAddress: TClientCaseIdentityVerificationUserFormCodec,
    SignOffAsReadyForExchange: TCaseSignOffAsReadyForExchangeFormCodec,
    SwapCaseMember: TCaseMemberSuggestedSimilarUserFormCodec,
    InstructCase: TCaseInstructFormCodec,
    GetCaseEpcSearch: TCaseEpcSearchFormCodec,
    AttachCaseEpcCertificate: TCaseEpcAttachFormCodec,
    RerunCaseEpcLookup: TCaseEpcRerunLookupFormCodec,
    MarkCaseEpcNotRequired: TCaseEpcMarkNotRequiredFormCodec,
    MarkCaseEpcNoneFound: TCaseEpcMarkNotRequiredFormCodec,
    SetCaseEpcSorted: TCaseEpcSetSortedFormCodec,
    SubmitClientCaseEpcWhoArranges: TClientCaseEpcWhoArrangesFormCodec,
    UpdateClientInitialPaymentUserSaysPaid: TClientCaseUserSaysPaymentPaidFormCodec,
    UpdateClientCaseCompanyName: TClientCaseCompanyFormCodec,
    CreateClientCaseUser: TClientCaseCreateUserFormCodec,
    DeleteClientCaseUser: TClientCaseUserFormCodec,
    UpdateClientCaseUser: TClientCaseUserFormCodec,
    SubmitClientCaseUsersStepComplete: TClientCaseSubmitStepAsCompleteFormCodec,
    CreateCaseAdHocJob: TCaseAdHocJobNewFormCodec,
    UpdateCaseAdHocJob: TCaseAdHocJobFormCodec,
    GetCaseRelatedSearch: TCaseRelatedTransactionCreateFormCodec,
    CreateCaseRelatedTransaction: TCaseRelatedTransactionCreateSearchResultsFormCodec,
    DeleteCaseRelatedTransaction: TCaseRelatedTransactionForm1Codec,
    UpdateClientCaseRelatedTransactionQuestion: TClientCaseRelatedTransactionQuestionFormCodec,
    AutocompleteRelatedTransactionAddress: TClientCaseRelatedTransactionAddressFormCodec,
    UpdateClientCaseRelatedTransactionAddress: TClientCaseRelatedTransactionAddressFormCodec,
    UpdateCaseRelatedTransaction: TCaseRelatedTransactionDataFormCodec,
    SendNewLegalEmail: TEmailCompositionFormCodec,
    ReplyLegalEmail: TEmailCompositionFormCodec,
    ForwardLegalEmail: TEmailCompositionFormCodec,
    CreateCaseVideoVerificationCall: TCaseVideoVerificationCallCreateFormCodec,
    UpdateCaseVideoVerificationCall: TCaseVideoVerificationCallListFormCodec,
    DeleteCaseVideoVerificationCall: TCaseVideoVerificationCallListFormCodec,
    AssociateCaseUserVideoVerificationCall: TCaseVideoVerificationCallAssociateWithUserFormCodec,
    UpdateCaseUserVideoVerificationCall: TCaseVideoVerificationCallUserFormCodec,
    LogPhoneVerificationCall: TCasePhoneVerificationCallLogFormCodec,
    CreateCasePhoneVerificationCall: TCaseVideoVerificationCallCreateFormCodec,
    DisassociateCaseUserVideoVerificationCall: TCaseVideoVerificationCallUserFormCodec,
    GetClientCaseVideoVerificationCallAvailableTimes: TClientCaseVideoVerificationCallAvailableTimesFormCodec,
    CreateClientCaseVideoVerificationCall: TClientCaseVideoVerificationCallCreateFormCodec,
    GetCaseEmailAttachmentOptions: TEmailAttachmentSearchFormCodec,
    UploadClientCaseProofOfAddressDocument: TClientCaseIdentityVerificationUserProofOfAddressFormCodec,
    UpdateClientCaseSdltQuestion: TClientCaseSdltFormCodec,
    SubmitClientCaseSdltQuestion: TClientCaseSdltFormCodec,
    SaveClientCasePurchasePaymentDetails: TClientCasePurchasePaymentDetailsFormCodec,
    SaveClientCaseDivorceDocument: TClientCaseDivorceDocumentFormCodec,
    SubmitClientCaseIlaWaiver: TClientCaseIlaWaiverFormCodec,
    SubmitClientCasePurchasePaymentDetailsAsFinal: TClientCasePurchasePaymentDetailsFormCodec,
    SubmitClientCaseRemortgageMortgageDetails: TClientCaseRemortgageMortgageDetailsFormCodec,
    SubmitClientCasePropertyInformationFormsStepComplete: TUuidFormCodec,
    UpdateClientCaseCasePif: TClientCaseCasePifFormCodec,
    UpdateClientCaseCasePifFreeText: TClientCaseUpdateCasePifFreeTextFormCodec,
    SetClientCaseCasePifDontKnow: TClientCaseSetCasePifDontKnowFormCodec,
    SignClientCaseCasePif: TClientCaseSignCasePifFormCodec,
    ReopenClientCaseCasePif: TUuidFormCodec,
    GetCaseCasePif: TCaseCasePifReadFormCodec,
    UpdateCaseSdlt: TCaseSdltFormCodec,
    SubmitCaseSdltDeclaration: TCaseSdltDeclarationFormCodec,
    GetTriageUnassignedSimpleEmails: TTriageFormCodec,
    GetTriageExpiredSimpleEmails: TTriageFormCodec,
    GetDetailedEmail: TDetailedEmailFormCodec,
    CaseLedgerRollback: TCaseLedgerRollbackFormCodec,
    SetTriageEmailAsIrrelevant: TTriageEmailMarkAsIrrelevantFormCodec,
    SetTriageEmailAsResolved: TTriageEmailMarkAsResolvedFormCodec,
    SetTriageEmailAsDisassociated: TTriageEmailDisassociateFromCaseFormCodec,
    AssignResolveAndCreateAdhocTriageEmail: TTriageEmailAssignToCaseWithAdhocFormCodec,
    AssignTriageEmailToUserOnly: TTriageEmailAssignToUserOnlyFormCodec,
    AssignTriageEmail: TTriageEmailAssignToCaseAndUserFormCodec,
    AssignAndResolveTriageEmail: TTriageEmailAssignToCaseFormCodec,

    GetAssigneeResolvedEmails: TTriageFormCodec,
    GetAssigneeUnresolvedEmails: TTriageFormCodec,
    GetUserUntriagedEmails: TTriageFormCodec,
    GetConfidentialEmails: TTriageFormCodec,
    GetCaseInboxEmails: TTriageFormCodec;
    ToggleAwayStatus: TToggleAwayStatusFormCodec,
    GetStaffInboxes: TGetStaffInboxesFormCodec,

    SetTriageBulkEmailsAsIrrelevant: TTriageBulkEmailMarkAsIrrelevantFormCodec,
    GetUnresolvedInboxCount: TInboxCountFormCodec,
    SubmitCaseRiskAssessment: TCaseNewRiskAssessmentFormCodec,
    UpdateCaseAuditComments: TCaseAuditFormCodec,
    SubmitCaseAuditAsComplete: TSubmitCaseAuditAsCompleteFormCodec,
    GetSearchForTriageEmails: TTriageEmailAssignToCaseSearchFormCodec,
    GetCaseChargesAndRestrictions: TCaseChargesAndRestrictionsFormCodec,
    UpdateCaseChargesAndTitleRestrictionsCase: TCaseChargesAndTitleRestrictionsCaseFormCodec,
    CreateCaseTitleRestriction: TCreateCaseTitleRestrictionFormCodec,
    UpdateCaseTitleRestriction: TCaseTitleRestrictionFormCodec,
    DeleteCaseTitleRestriction: TCaseTitleRestrictionFormCodec,
    UpdateClientCaseCharge: TClientCaseChargeFormCodec,
    SubmitClientCaseCharge: TClientCaseSubmitStepAsCompleteFormCodec,
    CreateCaseChargeRedemption: TCaseChargeRedemptionCreateFormCodec,
    UploadCaseChargeRedemption: TCaseChargeRedemptionUploadFormCodec,
    DeleteCaseChargeRedemption: TCaseChargeRedemptionFormCodec,
    CreateCaseCharge: TCreateCaseChargeFormCodec,
    UpdateCaseCharge: TCaseChargeFormCodec,
    DeleteCaseCharge: TCaseChargeFormCodec,

    GetIntroducers: TIntroducersFormCodec,
    CreateIntroducer: TIntroducerCreateFormCodec,
    UpdateIntroducer: TIntroducerFormCodec,
    UpdateIntroducerBankDetails: TIntroducerBankDetailsFormCodec,
    DeleteIntroducer: TIntroducerFormCodec,
    UploadIntroducerAgreement: TIntroducerUploadAgreementFormCodec,
    UploadIntroducerLogo: TIntroducerLogoFileIOCodec,
    DeleteIntroducerAgreement: TIntroducerExistingAgreementFormCodec,

    GetMarketingCampaigns: TMarketingCampaignsFormCodec,
    CreateMarketingCampaign: TMarketingCampaignCreateFormCodec,
    UpdateMarketingCampaign: TMarketingCampaignFormCodec,
    DeleteMarketingCampaign: TMarketingCampaignFormCodec,

    GetCaseCustomerSatisfaction: TCaseCustomerSatisfactionFormCodec,
    UpdateCaseCustomerSatisfactionPin: TCaseCustomerSatisfactionNoteTogglePinFormCodec,
    CreateCaseCustomerSatisfactionNote: TCaseCustomerSatisfactionNewNoteFormCodec,
    CreateCaseCustomerSatisfactionFormalisedAsComplaint: TCaseCustomerSatisfactionNewFormalisedAsComplaintFormCodec,
    CreateCaseCustomerSatisfactionRaisedWithOmbudsman: TCaseCustomerSatisfactionNewRaisedWithOmbudsmanFormCodec,
    CreateCaseCustomerSatisfactionComplaintAcknowledged: TCaseCustomerSatisfactionNewComplaintAcknowledgedFormCodec,
    CreateCaseCustomerSatisfactionComplaintResolved: TCaseCustomerSatisfactionNewComplaintResolvedFormCodec,
    CreateCaseCustomerSatisfactionSentiment: TCaseCustomerSatisfactionNewSentimentFormCodec,
    CreateCaseCustomerSatisfactionAssignment: TCaseCustomerSatisfactionNewAssignmentFormCodec,
    CreateCaseCustomerSatisfactionDefer: TCaseCustomerSatisfactionNewDeferFormCodec,

    DeleteCaseCustomerSatisfactionNote: TCaseCustomerSatisfactionDeleteNoteFormCodec,
    DeleteCustomerSatisfactionSentiment: TCaseCustomerSatisfactionDeleteSentimentFormCodec,
    DeleteCustomerSatisfactionRaisedWithOmbudsman: TCaseCustomerSatisfactionDeleteRaisedWithOmbudsmanFormCodec,
    DeleteCustomerSatisfactionRaisedAsComplaint: TCaseCustomerSatisfactionDeleteFormalisedAsComplaintFormCodec,
    DeleteCustomerSatisfactionComplaintAcknowledged: TCaseCustomerSatisfactionDeleteComplaintAcknowledgedFormCodec,
    DeleteCustomerSatisfactionComplaintResolved: TCaseCustomerSatisfactionDeleteComplaintResolvedFormCodec,

    GetCaseComplianceRaises: TCaseComplianceRaisesFormCodec,
    CreateCaseSarRaised: TCaseComplianceRaiseNewFormCodec,
    CreateCaseRaisedWithInsurers: TCaseComplianceRaiseNewFormCodec,
    UpdateCaseComplianceRaiseNote: TCaseComplianceRaiseFormCodec,
    RevokeCaseComplianceRaise: TCaseComplianceRaiseRevokeFormCodec,

    GetClientCompanyPartnerships: TClientCompanyPartnershipPageFormCodec,
    UpdateClientCompanyPartnership: TClientCompanyPartnershipFormCodec,
    CreateClientCompanyPartnership: TClientCompanyPartnershipCreateFormCodec,
    DeleteClientCompanyPartnership: TClientCompanyPartnershipDeleteFormCodec,
    ReviewClientCompanyPartnership: TClientCompanyPartnershipReviewFormCodec,
    UploadClientCompanyPartnershipContract: TClientCompanyPartnershipContractUploadFormCodec,
    DeleteClientCompanyPartnershipContract: TClientCompanyPartnershipContractFormCodec,
    AutocompleteClientCompanyPartnershipAddress: TClientCompanyPartnershipFormCodec,
    UpdateClientCompanyPartnershipUser: TClientCompanyPartnershipUserFormCodec,
    DisassociateClientCompanyPartnershipUser: TClientCompanyPartnershipUserFormCodec,
    CreateClientCompanyPartnershipUserPhoneNumber: TClientCompanyPartnershipUserPhoneNumberCreateFormCodec,
    SetClientCompanyPartnershipUserPhoneNumberPrimary: TClientCompanyPartnershipUserPhoneNumberMakePrimaryFormCodec,
    DeleteClientCompanyPartnershipUserPhoneNumber: TClientCompanyPartnershipUserPhoneNumberDeleteFormCodec,

    GetCaseDualRepSearch: TCaseDualRepCreateFormCodec,
    LinkCaseDualRep: TCaseDualRepSearchResultsFormCodec,
    UnlinkCaseDualRep: TCaseDualRepLinkedFormCodec,

    GetCaseListingSearch: TCaseListingSearchFormCodec,
    LinkCaseListing: TCaseListingSearchResultFormCodec,
    UnlinkCaseListing: TCaseLinkedListingFormCodec,

    GetProbateHelplineCallbacksNow: TProbateHelplineCallbackTypeFormCodec,
    GetProbateHelplineCallbacksCompleted: TProbateHelplineCallbackTypeFormCodec,
    UpdateProbateHelplineCallback: TProbateHelplineCallbackFormCodec,
    SetProbateHelplineCallbackComplete: TProbateHelplineCallbackMarkCompleteFormCodec,

    GetQuoteRates: TQuoteRatePageFormCodec,
    UpdateQuoteRate: TQuoteRateCreatedFormCodec,
    CreateQuoteRate: TQuoteRateIntroducerIdFormCodec,
    DeleteQuoteRate: TUuidFormCodec,
    ToggleDeleteOnNextPublishQuoteRate: TUuidFormCodec,
    SetDeleteOnNextPublishAndReplaceQuoteRate: TUuidFormCodec,
    PublishQuoteRates: TQuoteRateIntroducerIdFormCodec,

    CreateCaseQuote: TCreateCaseQuoteFilledFormCodec,
    UpdateCaseQuoteSentToClientStatus: TCaseQuoteSentToClientFormCodec,
    AddCaseQuoteAdditionalItem: TCaseQuoteAddAdditionalItemFormCodec,
    RemoveCaseQuoteAdditionalItem: TCaseQuoteRemoveAdditionalItemFormCodec,
    CreatePublicQuote: TPublicCreateQuoteFilledFormCodec,
    AutocompletePublicQuoteAddress: TPublicCreateQuoteAddressFormCodec,
    SendPublicQuoteInstructLink: TPublicQuoteInstructLinkFormCodec,

    GetRoadblocks: TRoadblocksFormCodec,
    GetCaseRoadblocks: TRoadblocksForm2Codec,
    GetCaseTimeline: TCaseTimelineFormCodec,
    CreateChatMessage: TChatsMessageFormCodec,
    UpdateChatMessage: TUpdateChatMessageFormCodec,
    SetChatMessagePinned: TSetChatMessagePinnedFormCodec,
    GetRoadblock: TRoadblockFormCodec,
    RefreshRoadblock: TRoadblockFormCodec,
    UpdateRoadblockChecklistItem: TRoadblockCheckListItemManualFormCodec,
    SubmitRoadblockSignOff: TRoadblockSignOffFormCodec,

    GetCaseAutoAssignmentRules: TCaseAutoAssignmentPageFormCodec,
    UpdateCaseAutoAssignmentRules: TCaseAutoAssignmentFormCodec,
    GetEmailTemplateContext: TEmailTemplateContextFormCodec,
    GetEmailTemplates: TEmailTemplatesFormCodec,
    UpdateEmailTemplate: TEmailTemplateFormCodec,
    GetLenders: TLendersPageFormCodec,
    UpdateLender: TLenderFormCodec,
    GetRoadblockAssignmentRules: TRoadblockAssignmentPageFormCodec,
    UpdateRoadblockAssignmentRules: TRoadblockAssignmentFormCodec,
    CreateProbateLead: TProbateLeadFormCodec,

    GetPublicPropertyReportTitleNumbers: TPublicPropertyReportTitleSearchFormCodec,
    CreatePublicPropertyReport: TPublicPropertyReportCreateFormCodec,
    GetPublicPropertyReportAddressSearch: TPublicPropertyReportAddressSearchFormCodec,
    GetPublicIntroducerSearch: TPublicIntroducerSearchFormCodec,

    UpdateSessionFeatureToggles: TSessionFeatureToggleFormCodec,

    UpdateClientCaseJointOwnershipHeldAsPreference: TClientCaseJointOwnershipHeldAsFormCodec,

    UpdateClientCaseDeclarationOfTrustReferral: TClientCaseDeclarationOfTrustReferralFormCodec,

    UpdateClientCaseWillReferral: TClientCaseWillReferralFormCodec,

    GetCasesCaseView: TCasesCaseViewFormCodec,
    GetCasesCaseViewCase: TCasesCaseFormCodec,
    CreateCasesCaseAdhoc: TCasesCaseCreateAdhocFormCodec,
    UpdateCasesCaseTask: TCasesCaseTaskFormUpdatableCodec,
    DeleteCasesCaseAdhoc: TCasesCaseTaskFormAdhocCodec,
    UpdateCasesCase: TCasesCaseFormCodec,
    GetCasesDayView: TCasesDayViewFormCodec,
    GetCasesSailHomesReport: TCasesSailHomesReportFormCodec,
    GetCasesDayViewRoadblocks: TCasesDayViewRoadblocksFormCodec,
    GetCasesDayViewWeekCounts: TCasesDayViewWeekCountsFormCodec,
    BulkRescheduleCasesDayTasks: TCasesDayViewBulkRescheduleFormCodec,
    BulkAwaitCasesDayRoadblocks: TCasesDayViewBulkAwaitFormCodec,
    AssignRoadblock: TRoadblockAssignFormCodec,
    AwaitRoadblock: TRoadblockAwaitFormCodec,
    CancelRoadblockAwait: TRoadblockCancelAwaitFormCodec,

    GetCaseChaseMode: TCaseChaseModeFormCodec,
    ChaseModeAccept: TChaseModeUpdateFormCodec,
    ChaseModeWorkableModeAcknowledge: TChaseModeUpdateFormCodec,
    ChaseModeCloseAwaitingNewCase: TCloseAwaitingNewCaseFormCodec,
    ChaseModeCloseCaseUnsuccessfully: TChaseModeUpdateFormCodec,
    ChaseModeCloseCaseOpenedInError: TChaseModeUpdateFormCodec,
    ChaseModeReopenCase: TChaseModeUpdateFormCodec,
    ChaseModeReject: TChaseModeUpdateFormCodec,
    ChaseModeSubmit: TChaseModeUpdateFormWithChaseReasonsCodec,
    ChaseModeSubmitToWorkable: TChaseModeUpdateFormCodec,

    CreateServiceBearerToken: TCreateServiceBearerTokenFormCodec,
    CreateIntroducerApiToken: TCreateIntroducerApiTokenFormCodec,
    RevokeIntroducerApiToken: TRevokeIntroducerApiTokenFormCodec,
    CreateStaffUser: TCreateStaffUserFormCodec,
    ChangeStaffUserPassword: TChangeStaffUserPasswordFormCodec,

    CreateLegalDraftContractPack: TUuidFormCodec,
    CreateCaseTransferSetupRecord: TNewTransferSetupRecordForCaseFormCodec,
    UpdateCaseTransferSetupRecord: TTransferSetupRecordFormCodec,
    DeleteCaseTransferSetupRecord: TTransferSetupRecordFormCodec,
    CreateTA13: TUuidFormCodec,
    CreateLegalESignCert: TUuidFormCodec,
    CreateTransferDisclaimer: TUuidFormCodec,
    GetListingValuation: TListingValuationFormIOCodec,
    GetListingValuationTab: TListingValuationTabFormIOCodec,
    GetListingRoadblocks: TListingRoadblocksFormCodec,
    GetListingRoadblocksDashboard: TListingRoadblocksDashboardFormCodec,
    GetListingRoadblocksDashboardWeekCounts: TListingRoadblocksDashboardWeekCountsFormCodec,
    GetListingRoadblock: TListingRoadblockDetailFormCodec,
    ListingValuationAction: TListingValuationActionFormIOCodec,
    SubmitListingToVal: TListingValSubmitFormIOCodec,
};

export const formOperationCodecs: TFormOperationCodecs = {
    GetPublicOffersPageOffers: PublicOffersPageFormIO,
    GetCase: LegalCaseFormIO,
    GetCaseContractSection: CaseContractSectionForm,
    GetCaseTitleChecks: CaseTitleChecksForm,
    UpdateCaseTitleCheck: CaseTitleCheckForm,
    CreateCasePropertyNewTitleIssueForm: CasePropertyNewTitleIssueForm,
    DeleteCasePropertyTitleIssue: CasePropertyDeleteTitleIssueForm,
    UpdateCaseContractSection: CaseContractDetailsForm,
    CreateCaseDeadlineChange: CreateCaseDeadlineChangeForm,
    DeleteCaseDeadlineChange: DeleteCaseDeadlineChangeForm,
    CreateCaseProperty: CaseNewPropertyForm,
    UpdateCaseProperty: CasePropertyForm,
    DeleteCaseProperty: CasePropertyForm,
    OrderCasePropertyTitleRegister: UuidForm,
    OrderCasePropertyReferredDocument: UuidForm,
    GetCasePropertyReferredDocuments: CasePropertyReferredDocumentsForm,
    CreateListingFromCaseProperty: UuidForm,
    UpdateLegalCase: CaseForm,
    BuyerSubmitsNewOffer: BuyerSubmitsNewOfferFormEditable,
    BuyerUpdatesConveyancerDetails: BuyerUpdatesConveyancerDetailsFormEditable,
    BuyerUpdatesMortgageBrokerDetails: BuyerUpdatesMortgageBrokerDetailsFormEditable,
    BuyerUpdatesProofOfFunds: BuyerUpdatesProofOfFundsFormEditable,
    BuyerUpdatesClientDetails: BuyerUpdatesClientDetailsFormEditable,
    GetTitleChecksPage: TitleChecksPageFormIO,
    AutocompleteCaseDetailsAddress: CasePropertyForm,
    CreateCaseMember: NewCaseMemberFormIO,
    RemoveCaseMember: RemoveCaseMemberFormIO,
    UpdateCaseMember: CaseMemberForm,
    UpdateCaseMemberCaseUser: CaseMemberChildrenForm,
    UpdateCaseMemberSourceOfWealth: CaseMemberSourceOfWealthForm,
    UpdateCaseMemberNoDigitalContactChannelExemption: CaseMemberNoDigitalContactChannelExemptionForm,
    CreateUserNumber: NewUserNumberFormIO,
    UpdateUserNumber: PhoneNumberForm,
    RemoveUserNumber: RemoveUserNumberFormIO,
    GetListingData: ListingDataFormIO,
    GetListingPnl: ListingPnlFormIO,
    GetListingsProfitReport: ListingsProfitReportFormIO,
    UpdateListingFull: ListingFull1Editable,
    GetPartyData: PartyDataFormIO,
    UpdateParty: Party1Editable,
    PartyMemberCreate: PartyMemberCreateForm,
    AddPartyListing: AddPartyListingForm,
    GetJobs: JobsFormIO,
    CreateListingAdHocTask: NewListingAdHocTaskFormIO,
    UpdateListingAdHocTask: ListingAdHocTaskEditable,
    UploadListingPhoto: ListingPhotoFileIO,
    UploadListingDocument: ListingDocumentFileIO,
    DeleteListingDocument: DeleteListingDocumentFormIO,
    DeleteListingPhoto: DeleteListingPhotoFormIO,
    UploadProofOfFundsDocument: ProofOfFundsDocumentFileIO,
    DeleteProofOfFundsDocument: DeleteProofOfFundsDocumentFormIO,
    GetProofOfFundsDocuments: GetProofOfFundsDocumentsFormIO,
    UpdateUserLegalMailboxAccess: LegalMailboxAccessEditForm,
    UpdateListingDocument: ListingDocumentEditable,
    GetListingEnquiry: ListingEnquiryForm,
    UpdateListingEnquiry: ListingEnquiryInnerForm,
    CreateListingSignMovement: ListingSignMovementCreateForm,
    UpdateListingSignMovement: ListingSignMovementEditForm,
    DeleteListingSignMovement: ListingSignMovementEditForm,
    CreateListingEnquiryAdHocTask: ListingEnquiryNewAdHocTaskForm,
    UpdateListingEnquiryAdHocTask: ListingEnquiryAdHocTasksForm,
    ReassignListingAdHocTask: AdHocTaskReassignFormIO,
    ReassignListingEnquiryAdHocTask: AdHocTaskReassignFormIO,
    DeferListingAdHocTask: AdHocTaskDeferFormIO,
    DeferListingEnquiryAdHocTask: AdHocTaskDeferFormIO,
    GetAdminPage: AdminPageFormIO,
    UpdateAdminUser: AdminUserEditable,
    GetUserDeletionBlockers: GetUserDeletionBlockersFormIO,
    AutoReassignUserWork: AutoReassignUserWorkFormIO,
    UpdateListingEnquiryOffer: ListingEnquiryOfferForm,
    ListingSellerUserCreate: ListingSellerUserCreateForm,
    ListingSellerUserEdit: ListingSellerUserEditForm,
    ListingSellerUserDelete: ListingSellerUserDeleteForm,
    MarkListingAgencyLost: MarkListingAgencyLostForm,
    ReinstateListing: ReinstateListingForm,
    ConfirmListingBackOnPortals: ConfirmListingBackOnPortalsForm,
    ConfirmProbateGrantMatch: ProbateGrantMatchActionForm,
    DismissProbateGrantMatch: ProbateGrantMatchActionForm,
    SendListingToAuction: SendListingToAuctionForm,
    TakeListingLive: TakeListingLiveForm,
    UnsendListingFromAuction: UnsendListingFromAuctionForm,
    ListingSwapSellerPartyMember: ListingSellerSuggestedSimilarUserForm,
    CasesSearch: CasesSearchForm,
    CreateCaseOtherSideMember: CaseNewOtherSideMemberForm,
    UpdateCaseOtherSideMember: CaseOtherSideMemberForm,
    DeleteCaseOtherSideMember: CaseOtherSideMemberForm,
    GetCaseManagementCompanies: CaseManagementCompaniesForm,
    GetManagementCompanySearch: ManagementCompanySearchForm,
    CreateCaseManagementCompany: CreateCaseManagementCompanyForm,
    UpdateCaseManagementCompany: CaseManagementCompanyForm,
    DeleteCaseManagementCompany: CaseManagementCompanyForm,
    GetTwoFactorAuth: TwoFactorAuthForm,
    GetAuthenticatorPage: AuthenticatorPageForm,
    BeginAuthenticatorEnrolment: BeginAuthenticatorEnrolmentForm,
    ConfirmAuthenticatorEnrolment: ConfirmAuthenticatorEnrolmentForm,
    RemoveAuthenticator: RemoveAuthenticatorForm,
    AdminResetUserAuthenticator: AdminResetUserAuthenticatorForm,
    SubmitTwoFactorAuthCode: TwoFactorAuthCodeForm,
    ResendTwoFactorAuthCode: ResendTwoFactorAuthCodeForm,
    GetClientCase: ClientCaseForm,
    SendClientCaseOnboardingCompleteEmail: ClientCaseOnboardingCompleteEmailForm,
    SubmitClientCaseUserAgreeToTOEStepAsComplete: ClientCaseSubmitStepAsCompleteForm,
    SubmitClientCaseUserPepDeclarationStepAsComplete: ClientCasePepDeclarationSubmitForm,
    SubmitClientCaseUserDualRepConsentStepAsComplete: ClientCaseSubmitStepAsCompleteForm,
    SendCaseInstructedEmail: CaseSendInstructedEmailForm,
    CreateClientCaseBankAccount: ClientCaseCreateBankAccountForm,
    UpdateClientCaseBankAccount: ClientCaseBankAccountForm,
    DeleteClientCaseBankAccount: ClientCaseBankAccountForm,
    SubmitClientCaseBankAccountsForVerification: ClientCaseSubmitBankAccountsForVerificationForm,
    GetLegalCasesKeyDates: LegalCasesKeyDatesFormIO,
    UpdateCaseBankAccount: CaseBankAccountForm,
    SetCasePayoutRecipient: CaseSetPayoutRecipientForm,
    CreateCaseLedgerEntry: CaseNewLedgerEntryForm,
    GetCaseLedger: CaseLedgerForm,
    DeleteCaseLedgerEntry: CaseLedgerEntryForm,
    UpdateCaseLedgerEntry: CaseLedgerEntryForm,
    CreateStripeIdVerificationLink: ClientCaseCreateIdVerificationLinkForm,
    UpdateClientCaseUserIdCheck: ClientCaseIdentityVerificationUserForm,
    CreateCaseMemberIdCheck: CaseMemberCreateIdCheckForm,
    UpdateCaseMemberIdCheck: CaseMemberIdCheckForm,
    ReScreenCaseMemberIdCheck: CaseMemberReScreenIdCheckForm,
    RunScreeningCaseMemberIdCheck: CaseMemberRunScreeningIdCheckForm,
    FlagCaseMemberNeedsVideoCall: CaseMemberFlagNeedsVideoCallForm,
    UpdateCaseConflictOfInterest: CaseConflictOfInterestForm,
    CaseLedgerMarkLedgerAsFinal: CaseLedgerMarkLedgerAsFinalForm,
    AutocompleteClientVerificationAddress: ClientCaseIdentityVerificationUserForm,
    SignOffAsReadyForExchange: CaseSignOffAsReadyForExchangeForm,
    SwapCaseMember: CaseMemberSuggestedSimilarUserForm,
    InstructCase: CaseInstructForm,
    GetCaseEpcSearch: CaseEpcSearchForm,
    AttachCaseEpcCertificate: CaseEpcAttachForm,
    RerunCaseEpcLookup: CaseEpcRerunLookupForm,
    MarkCaseEpcNotRequired: CaseEpcMarkNotRequiredForm,
    MarkCaseEpcNoneFound: CaseEpcMarkNotRequiredForm,
    SetCaseEpcSorted: CaseEpcSetSortedForm,
    SubmitClientCaseEpcWhoArranges: ClientCaseEpcWhoArrangesForm,
    UpdateClientInitialPaymentUserSaysPaid: ClientCaseUserSaysPaymentPaidForm,
    UpdateClientCaseCompanyName: ClientCaseCompanyForm,
    CreateClientCaseUser: ClientCaseCreateUserForm,
    DeleteClientCaseUser: ClientCaseUserForm,
    UpdateClientCaseUser: ClientCaseUserForm,
    SubmitClientCaseUsersStepComplete: ClientCaseSubmitStepAsCompleteForm,
    CreateCaseAdHocJob: CaseAdHocJobNewForm,
    UpdateCaseAdHocJob: CaseAdHocJobForm,
    GetCaseRelatedSearch: CaseRelatedTransactionCreateForm,
    CreateCaseRelatedTransaction: CaseRelatedTransactionCreateSearchResultsForm,
    DeleteCaseRelatedTransaction: CaseRelatedTransactionForm1,
    UpdateClientCaseRelatedTransactionQuestion: ClientCaseRelatedTransactionQuestionForm,
    AutocompleteRelatedTransactionAddress: ClientCaseRelatedTransactionAddressForm,
    UpdateClientCaseRelatedTransactionAddress: ClientCaseRelatedTransactionAddressForm,
    UpdateCaseRelatedTransaction: CaseRelatedTransactionDataForm,
    SendNewLegalEmail: EmailCompositionForm,
    ReplyLegalEmail: EmailCompositionForm,
    ForwardLegalEmail: EmailCompositionForm,
    CreateCaseVideoVerificationCall: CaseVideoVerificationCallCreateForm,
    UpdateCaseVideoVerificationCall: CaseVideoVerificationCallListForm,
    DeleteCaseVideoVerificationCall: CaseVideoVerificationCallListForm,
    AssociateCaseUserVideoVerificationCall: CaseVideoVerificationCallAssociateWithUserForm,
    UpdateCaseUserVideoVerificationCall: CaseVideoVerificationCallUserForm,
    LogPhoneVerificationCall: CasePhoneVerificationCallLogForm,
    CreateCasePhoneVerificationCall: CaseVideoVerificationCallCreateForm,
    DisassociateCaseUserVideoVerificationCall: CaseVideoVerificationCallUserForm,
    GetClientCaseVideoVerificationCallAvailableTimes: ClientCaseVideoVerificationCallAvailableTimesForm,
    CreateClientCaseVideoVerificationCall: ClientCaseVideoVerificationCallCreateForm,
    GetCaseEmailAttachmentOptions: EmailAttachmentSearchForm,
    UploadClientCaseProofOfAddressDocument: ClientCaseIdentityVerificationUserProofOfAddressForm,
    UpdateClientCaseSdltQuestion: ClientCaseSdltForm,
    SubmitClientCaseSdltQuestion: ClientCaseSdltForm,
    SaveClientCasePurchasePaymentDetails: ClientCasePurchasePaymentDetailsForm,
    SaveClientCaseDivorceDocument: ClientCaseDivorceDocumentForm,
    SubmitClientCaseIlaWaiver: ClientCaseIlaWaiverForm,
    SubmitClientCasePurchasePaymentDetailsAsFinal: ClientCasePurchasePaymentDetailsForm,
    SubmitClientCaseRemortgageMortgageDetails: ClientCaseRemortgageMortgageDetailsForm,
    SubmitClientCasePropertyInformationFormsStepComplete: UuidForm,
    UpdateClientCaseCasePif: ClientCaseCasePifForm,
    UpdateClientCaseCasePifFreeText: ClientCaseUpdateCasePifFreeTextForm,
    SetClientCaseCasePifDontKnow: ClientCaseSetCasePifDontKnowForm,
    SignClientCaseCasePif: ClientCaseSignCasePifForm,
    ReopenClientCaseCasePif: UuidForm,
    GetCaseCasePif: CaseCasePifReadForm,
    UpdateCaseSdlt: CaseSdltForm,
    SubmitCaseSdltDeclaration: CaseSdltDeclarationForm,
    GetTriageUnassignedSimpleEmails: TriageForm,
    GetTriageExpiredSimpleEmails: TriageForm,
    GetDetailedEmail: DetailedEmailForm,
    CaseLedgerRollback: CaseLedgerRollbackForm,
    SetTriageEmailAsIrrelevant: TriageEmailMarkAsIrrelevantForm,
    SetTriageEmailAsResolved: TriageEmailMarkAsResolvedForm,
    SetTriageEmailAsDisassociated: TriageEmailDisassociateFromCaseForm,
    AssignResolveAndCreateAdhocTriageEmail: TriageEmailAssignToCaseWithAdhocForm,
    AssignTriageEmailToUserOnly: TriageEmailAssignToUserOnlyForm,
    AssignTriageEmail: TriageEmailAssignToCaseAndUserForm,
    AssignAndResolveTriageEmail: TriageEmailAssignToCaseForm,

    GetAssigneeResolvedEmails: TriageForm,
    GetAssigneeUnresolvedEmails: TriageForm,
    GetUserUntriagedEmails: TriageForm,
    GetConfidentialEmails: TriageForm,
    GetCaseInboxEmails: TriageForm,
    ToggleAwayStatus: ToggleAwayStatusForm,
    GetStaffInboxes: GetStaffInboxesForm,

    SetTriageBulkEmailsAsIrrelevant: TriageBulkEmailMarkAsIrrelevantForm,
    GetUnresolvedInboxCount: InboxCountForm,
    SubmitCaseRiskAssessment: CaseNewRiskAssessmentForm,
    UpdateCaseAuditComments: CaseAuditForm,
    SubmitCaseAuditAsComplete: SubmitCaseAuditAsCompleteForm,
    GetSearchForTriageEmails: TriageEmailAssignToCaseSearchForm,
    GetCaseChargesAndRestrictions: CaseChargesAndRestrictionsForm,
    UpdateCaseChargesAndTitleRestrictionsCase: CaseChargesAndTitleRestrictionsCaseForm,
    CreateCaseTitleRestriction: CreateCaseTitleRestrictionForm,
    UpdateCaseTitleRestriction: CaseTitleRestrictionForm,
    DeleteCaseTitleRestriction: CaseTitleRestrictionForm,
    UpdateClientCaseCharge: ClientCaseChargeForm,
    SubmitClientCaseCharge: ClientCaseSubmitStepAsCompleteForm,
    CreateCaseChargeRedemption: CaseChargeRedemptionCreateForm,
    UploadCaseChargeRedemption: CaseChargeRedemptionUploadForm,
    DeleteCaseChargeRedemption: CaseChargeRedemptionForm,
    CreateCaseCharge: CreateCaseChargeForm,
    UpdateCaseCharge: CaseChargeForm,
    DeleteCaseCharge: CaseChargeForm,

    GetIntroducers: IntroducersForm,
    CreateIntroducer: IntroducerCreateForm,
    UpdateIntroducer: IntroducerForm,
    UpdateIntroducerBankDetails: IntroducerBankDetailsForm,
    DeleteIntroducer: IntroducerForm,
    UploadIntroducerAgreement: IntroducerUploadAgreementForm,
    UploadIntroducerLogo: IntroducerLogoFileIO,
    DeleteIntroducerAgreement: IntroducerExistingAgreementForm,

    GetMarketingCampaigns: MarketingCampaignsForm,
    CreateMarketingCampaign: MarketingCampaignCreateForm,
    UpdateMarketingCampaign: MarketingCampaignForm,
    DeleteMarketingCampaign: MarketingCampaignForm,

    GetCaseCustomerSatisfaction: CaseCustomerSatisfactionForm,
    UpdateCaseCustomerSatisfactionPin: CaseCustomerSatisfactionNoteTogglePinForm,
    CreateCaseCustomerSatisfactionNote: CaseCustomerSatisfactionNewNoteForm,
    CreateCaseCustomerSatisfactionFormalisedAsComplaint: CaseCustomerSatisfactionNewFormalisedAsComplaintForm,
    CreateCaseCustomerSatisfactionRaisedWithOmbudsman: CaseCustomerSatisfactionNewRaisedWithOmbudsmanForm,
    CreateCaseCustomerSatisfactionComplaintAcknowledged: CaseCustomerSatisfactionNewComplaintAcknowledgedForm,
    CreateCaseCustomerSatisfactionComplaintResolved: CaseCustomerSatisfactionNewComplaintResolvedForm,
    CreateCaseCustomerSatisfactionSentiment: CaseCustomerSatisfactionNewSentimentForm,
    CreateCaseCustomerSatisfactionAssignment: CaseCustomerSatisfactionNewAssignmentForm,
    CreateCaseCustomerSatisfactionDefer: CaseCustomerSatisfactionNewDeferForm,

    DeleteCaseCustomerSatisfactionNote: CaseCustomerSatisfactionDeleteNoteForm,
    DeleteCustomerSatisfactionSentiment: CaseCustomerSatisfactionDeleteSentimentForm,
    DeleteCustomerSatisfactionRaisedWithOmbudsman: CaseCustomerSatisfactionDeleteRaisedWithOmbudsmanForm,
    DeleteCustomerSatisfactionRaisedAsComplaint: CaseCustomerSatisfactionDeleteFormalisedAsComplaintForm,
    DeleteCustomerSatisfactionComplaintAcknowledged: CaseCustomerSatisfactionDeleteComplaintAcknowledgedForm,
    DeleteCustomerSatisfactionComplaintResolved: CaseCustomerSatisfactionDeleteComplaintResolvedForm,

    GetCaseComplianceRaises: CaseComplianceRaisesForm,
    CreateCaseSarRaised: CaseComplianceRaiseNewForm,
    CreateCaseRaisedWithInsurers: CaseComplianceRaiseNewForm,
    UpdateCaseComplianceRaiseNote: CaseComplianceRaiseForm,
    RevokeCaseComplianceRaise: CaseComplianceRaiseRevokeForm,

    GetClientCompanyPartnerships: ClientCompanyPartnershipPageForm,
    UpdateClientCompanyPartnership: ClientCompanyPartnershipForm,
    CreateClientCompanyPartnership: ClientCompanyPartnershipCreateForm,
    DeleteClientCompanyPartnership: ClientCompanyPartnershipDeleteForm,
    ReviewClientCompanyPartnership: ClientCompanyPartnershipReviewForm,
    UploadClientCompanyPartnershipContract: ClientCompanyPartnershipContractUploadForm,
    DeleteClientCompanyPartnershipContract: ClientCompanyPartnershipContractForm,
    AutocompleteClientCompanyPartnershipAddress: ClientCompanyPartnershipForm,
    UpdateClientCompanyPartnershipUser: ClientCompanyPartnershipUserForm,
    DisassociateClientCompanyPartnershipUser: ClientCompanyPartnershipUserForm,
    CreateClientCompanyPartnershipUserPhoneNumber: ClientCompanyPartnershipUserPhoneNumberCreateForm,
    SetClientCompanyPartnershipUserPhoneNumberPrimary: ClientCompanyPartnershipUserPhoneNumberMakePrimaryForm,
    DeleteClientCompanyPartnershipUserPhoneNumber: ClientCompanyPartnershipUserPhoneNumberDeleteForm,

    GetCaseDualRepSearch: CaseDualRepCreateForm,
    LinkCaseDualRep: CaseDualRepSearchResultsForm,
    UnlinkCaseDualRep: CaseDualRepLinkedForm,

    GetCaseListingSearch: CaseListingSearchForm,
    LinkCaseListing: CaseListingSearchResultForm,
    UnlinkCaseListing: CaseLinkedListingForm,

    GetProbateHelplineCallbacksNow: ProbateHelplineCallbackTypeForm,
    GetProbateHelplineCallbacksCompleted: ProbateHelplineCallbackTypeForm,
    UpdateProbateHelplineCallback: ProbateHelplineCallbackForm,
    SetProbateHelplineCallbackComplete: ProbateHelplineCallbackMarkCompleteForm,

    GetQuoteRates: QuoteRatePageForm,
    UpdateQuoteRate: QuoteRateCreatedForm,
    CreateQuoteRate: QuoteRateIntroducerIdForm,
    DeleteQuoteRate: UuidForm,
    ToggleDeleteOnNextPublishQuoteRate: UuidForm,
    SetDeleteOnNextPublishAndReplaceQuoteRate: UuidForm,
    PublishQuoteRates: QuoteRateIntroducerIdForm,

    CreateCaseQuote: CreateCaseQuoteFilledForm,
    UpdateCaseQuoteSentToClientStatus: CaseQuoteSentToClientForm,
    AddCaseQuoteAdditionalItem: CaseQuoteAddAdditionalItemForm,
    RemoveCaseQuoteAdditionalItem: CaseQuoteRemoveAdditionalItemForm,
    CreatePublicQuote: PublicCreateQuoteFilledForm,
    AutocompletePublicQuoteAddress: PublicCreateQuoteAddressForm,
    SendPublicQuoteInstructLink: PublicQuoteInstructLinkForm,

    GetRoadblocks: RoadblocksForm,
    GetCaseRoadblocks: RoadblocksForm2,
    GetCaseTimeline: CaseTimelineForm,
    CreateChatMessage: ChatsMessageForm,
    UpdateChatMessage: UpdateChatMessageForm,
    SetChatMessagePinned: SetChatMessagePinnedForm,
    GetRoadblock: RoadblockForm,
    RefreshRoadblock: RoadblockForm,
    UpdateRoadblockChecklistItem: RoadblockCheckListItemManualForm,
    SubmitRoadblockSignOff: RoadblockSignOffForm,

    GetCaseAutoAssignmentRules: CaseAutoAssignmentPageForm,
    UpdateCaseAutoAssignmentRules: CaseAutoAssignmentForm,
    GetEmailTemplateContext: EmailTemplateContextForm,
    GetEmailTemplates: EmailTemplatesForm,
    UpdateEmailTemplate: EmailTemplateForm,
    GetLenders: LendersPageForm,
    UpdateLender: LenderForm,
    GetRoadblockAssignmentRules: RoadblockAssignmentPageForm,
    UpdateRoadblockAssignmentRules: RoadblockAssignmentForm,

    CreateProbateLead: ProbateLeadForm,

    GetPublicPropertyReportTitleNumbers: PublicPropertyReportTitleSearchForm,
    CreatePublicPropertyReport: PublicPropertyReportCreateForm,
    GetPublicPropertyReportAddressSearch: PublicPropertyReportAddressSearchForm,
    GetPublicIntroducerSearch: PublicIntroducerSearchForm,

    UpdateSessionFeatureToggles: SessionFeatureToggleForm,

    UpdateClientCaseJointOwnershipHeldAsPreference: ClientCaseJointOwnershipHeldAsForm,

    UpdateClientCaseDeclarationOfTrustReferral: ClientCaseDeclarationOfTrustReferralForm,

    UpdateClientCaseWillReferral: ClientCaseWillReferralForm,

    GetCasesCaseView: CasesCaseViewForm,
    GetCasesCaseViewCase: CasesCaseForm,
    CreateCasesCaseAdhoc: CasesCaseCreateAdhocForm,
    UpdateCasesCaseTask: CasesCaseTaskFormUpdatableForCasesView,
    DeleteCasesCaseAdhoc: CasesCaseTaskFormAdhocForCasesView,
    UpdateCasesCase: CasesCaseForm,
    GetCasesDayView: CasesDayViewForm,
    GetCasesSailHomesReport: CasesSailHomesReportForm,
    GetCasesDayViewRoadblocks: CasesDayViewRoadblocksForm,
    GetCasesDayViewWeekCounts: CasesDayViewWeekCountsForm,
    BulkRescheduleCasesDayTasks: CasesDayViewBulkRescheduleForm,
    BulkAwaitCasesDayRoadblocks: CasesDayViewBulkAwaitForm,
    AssignRoadblock: RoadblockAssignForm,
    AwaitRoadblock: RoadblockAwaitForm,
    CancelRoadblockAwait: RoadblockCancelAwaitForm,

    GetCaseChaseMode: CaseChaseModeForm,
    ChaseModeAccept: ChaseModeUpdateForm,
    ChaseModeWorkableModeAcknowledge: ChaseModeUpdateForm,
    ChaseModeCloseAwaitingNewCase: CloseAwaitingNewCaseForm,
    ChaseModeCloseCaseUnsuccessfully: ChaseModeUpdateForm,
    ChaseModeCloseCaseOpenedInError: ChaseModeUpdateForm,
    ChaseModeReopenCase: ChaseModeUpdateForm,
    ChaseModeReject: ChaseModeUpdateForm,
    ChaseModeSubmit: ChaseModeUpdateFormWithChaseReasons,
    ChaseModeSubmitToWorkable: ChaseModeUpdateForm,

    CreateServiceBearerToken: CreateServiceBearerTokenForm,
    CreateIntroducerApiToken: CreateIntroducerApiTokenForm,
    RevokeIntroducerApiToken: RevokeIntroducerApiTokenForm,
    CreateStaffUser: CreateStaffUserForm,
    ChangeStaffUserPassword: ChangeStaffUserPasswordForm,

    CreateLegalDraftContractPack: UuidForm,
    CreateCaseTransferSetupRecord: NewTransferSetupRecordForCaseForm,
    UpdateCaseTransferSetupRecord: TransferSetupRecordForm,
    DeleteCaseTransferSetupRecord: TransferSetupRecordForm,
    CreateTA13: UuidForm,
    CreateLegalESignCert: UuidForm,
    CreateTransferDisclaimer: UuidForm,
    GetListingValuation: ListingValuationFormIO,
    GetListingValuationTab: ListingValuationTabFormIO,
    GetListingRoadblocks: ListingRoadblocksForm,
    GetListingRoadblocksDashboard: ListingRoadblocksDashboardForm,
    GetListingRoadblocksDashboardWeekCounts: ListingRoadblocksDashboardWeekCountsForm,
    GetListingRoadblock: ListingRoadblockDetailForm,
    ListingValuationAction: ListingValuationActionFormIO,
    SubmitListingToVal: ListingValSubmitFormIO,
};

export type TFormOperationName = keyof TFormOperationCodecs;

export const formOperationNameCodec = union(pipe(
    (record.keys(formOperationCodecs) as NonEmptyArray<TFormOperationName>),
    nonEmptyArray.map((v) => literal(v)))
);

export const getContentType = (operation: TFormOperationName): ContentType.T => {
    if (formOperationCodecs[operation].type === "FileIOCodec") {
        return ContentType.constants.OCTECT_STREAM;
    }
    return ContentType.constants.JSON;
};